import { bgImageWithoutTextDesktop, bgImageWithoutTextMobile, bgImageWithTextDesktop, bgImageWithTextMobile, bgImageWithTextTablet } from "./constants";
export const getBgImageWithText = (screenSize: string) => {
  switch (screenSize) {
    case "mobile":
      return bgImageWithTextMobile;
    case "tablet":
      return bgImageWithTextTablet;
    default:
      return bgImageWithTextDesktop;
  }
};
export const getBgImageWithoutText = (screenSize: string) => {
  return screenSize === "mobile" ? bgImageWithoutTextMobile : bgImageWithoutTextDesktop;
};
export function getAdBackgroundStyles(screenSize: string, showTextBackground: boolean) {
  const bgImageWithText = getBgImageWithText(screenSize);
  const bgImageNoText = getBgImageWithoutText(screenSize);
  return {
    backgroundColor: "#DCF6FF",
    backgroundImage: `url(${showTextBackground ? bgImageWithText : bgImageNoText})`,
    backgroundSize: "contain",
    backgroundPosition: "right center",
    backgroundRepeat: "no-repeat"
  };
}
export default getAdBackgroundStyles;